import { Messages } from "../../core/api";
import Select, { CustomSelectProps } from "./Select";
import SelectNoResults from "./SelectNoResults";

const statusOptions = [
  { value: "ACTIVE", label: "Active" },
  { value: "ON_HOLD", label: "On Hold" },
  { value: "ON_LEAVE", label: "On Leave" },
  { value: "PENDING", label: "Pending" },
  { value: "SUSPENDED", label: "Inactive" },
  { value: "TERMINATED", label: "Terminated" },
  { value: "QUIT", label: "Quit" },
  { value: "REJECTED", label: "Rejected" },
  { value: "JOIN_REQUEST", label: "Join Request" },
] as const;

export default function CaregiverStatusSelect(
  props: CustomSelectProps<Messages["CaregiverStatus"]>
) {
  return (
    <Select
      label={props.multiple ? "Statuses" : "Status"}
      options={statusOptions}
      renderAfter={({ searchTerm, filteredOptions }) =>
        filteredOptions.length === 0 && <SelectNoResults searchTerm={searchTerm} />
      }
      {...props}
    />
  );
}
